'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploadAttachment = exports.clearElementAttachmentError = exports.errorUploadingElementAttachment = exports.cleanElementAttachment = exports.completedUploadingElementAttachment = exports.progressUploadingElementAttachment = exports.readElementAttachment = exports.uploadingElementAttachment = undefined;

var _elementConstants = require('../../common/elements/elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

var _imageFileLoader = require('../utils/services/image/imageFileLoader');

var _imageFileLoader2 = _interopRequireDefault(_imageFileLoader);

var _mediaService = require('../utils/services/mediaService');

var _mediaService2 = _interopRequireDefault(_mediaService);

var _elementActions = require('./elementActions');

var _mediaConstants = require('../../common/media/mediaConstants');

var _undoRedoTransactionManager = require('../utils/undoRedo/undoRedoTransactionManager');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Uploading attachments


// Constants
var uploadingElementAttachment = exports.uploadingElementAttachment = function uploadingElementAttachment(_ref) {
    var id = _ref.id;
    return { type: TYPES.ELEMENT_ATTACHMENT_UPLOADING, id: id, sync: false };
};

// TODO Review where these files are located
var readElementAttachment = exports.readElementAttachment = function readElementAttachment(_ref2) {
    var id = _ref2.id,
        attachmentData = _ref2.attachmentData;
    return {
        type: TYPES.ELEMENT_ATTACHMENT_DATA_READY,
        id: id,
        attachmentData: attachmentData,
        sync: false
    };
};
var progressUploadingElementAttachment = exports.progressUploadingElementAttachment = function progressUploadingElementAttachment(_ref3) {
    var id = _ref3.id,
        percentageComplete = _ref3.percentageComplete;
    return {
        type: TYPES.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED,
        id: id,
        percentageComplete: percentageComplete,
        sync: false
    };
};
var completedUploadingElementAttachment = exports.completedUploadingElementAttachment = function completedUploadingElementAttachment(_ref4) {
    var id = _ref4.id;
    return {
        type: TYPES.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED,
        id: id,
        sync: false
    };
};
var cleanElementAttachment = exports.cleanElementAttachment = function cleanElementAttachment(_ref5) {
    var id = _ref5.id;
    return {
        type: TYPES.ELEMENT_ATTACHMENT_CLEAN,
        id: id,
        sync: false
    };
};
var errorUploadingElementAttachment = exports.errorUploadingElementAttachment = function errorUploadingElementAttachment(_ref6) {
    var id = _ref6.id,
        error = _ref6.error;
    return {
        type: TYPES.ELEMENT_ATTACHMENT_UPLOAD_ERROR,
        id: id,
        error: error,
        sync: false
    };
};
var clearElementAttachmentError = exports.clearElementAttachmentError = function clearElementAttachmentError(_ref7) {
    var id = _ref7.id;
    return {
        type: TYPES.ELEMENT_ATTACHMENT_CLEAR_ERROR,
        id: id,
        sync: false
    };
};

/**
 * Uploads an attachment on an element.
 *
 * @param id {String} The ID of the element to add an attachment for.
 * @param file {File} The File object to add as an attachment to the element.
 * @param transactionId {Number} A transaction ID that this action is associated to. Used to group undo / redo actions.
 * @param imageType {String} The type of image to upload (sets sizes that the image will be saved at etc).
 *      'BOARD' || 'ELEMENT'.
 */
// TODO - NOTE this is currently very specific to uploading images.  Will likely need a different action for other
// file types
var uploadAttachment = exports.uploadAttachment = function uploadAttachment(_ref8) {
    var id = _ref8.id,
        file = _ref8.file,
        _ref8$transactionId = _ref8.transactionId,
        transactionId = _ref8$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref8$transactionId,
        imageType = _ref8.imageType;
    return function (dispatch, getState) {
        var state = getState();
        var isGuest = state.getIn(['app', 'currentUser', 'isGuest']);

        // First notify the application that a file upload is in progress
        if (!isGuest) dispatch(uploadingElementAttachment({ id: id }));

        // TODO Handle errors
        // Handles orientations of JPEGs if necessary
        return (0, _imageFileLoader2.default)(file).then(function (imageData) {
            var imageDataUri = imageData.imageDataUri;

            var imageFile = imageData.file;

            // Read the file so we can immediately show the image to the user
            dispatch(readElementAttachment({ id: id, attachmentData: imageDataUri }));

            // If the user is guest, don't upload the image
            if (isGuest) return;

            return _mediaService2.default.image.uploadMediaFile(imageFile, { slug: id, type: imageType || _mediaConstants.IMAGE_TYPES.ELEMENT }).then(function (response) {
                dispatch(completedUploadingElementAttachment({ id: id }));
                dispatch((0, _elementActions.updateElement)({ id: id, changes: response.data, transactionId: transactionId }));
            }).catch(function (err) {
                console.error('An error occurred while uploading the image', err, err.response);
                dispatch(errorUploadingElementAttachment({
                    id: id,
                    transactionId: transactionId,
                    error: { message: 'The image failed to upload' }
                }));
            });
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementAttachmentActions.js
// module id = 142
// module chunks = 0